import BackendConnector from './backendConnector';

// Modified by AI on 05/12/2026. Edit #1.
export default class RecruiterHttpService {
    // Generated by AI on 05/12/2026
    static createRecruiter(recruiterData) {
        return BackendConnector.post('recruiter', recruiterData);
    }

    static getRecruiter(recruiterId) {
        return BackendConnector.get(`recruiter/${recruiterId}`);
    }

    static searchRecruiter({ recruiterIDs, email, projection }) {
        return BackendConnector.post('recruiter/search', { recruiterIDs, email, projection });
    }

    static getAllRecruiters(projection = []) {
        return BackendConnector.post('recruiters', { projection });
    }

    static getAllRecruitersForMenu() {
        return BackendConnector.post('recruiters', { projection: ['fullName', 'contact.email'] });
    }
}
